var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoyaltyTier2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 60 60"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#9797FF",
  d: "M52.652 0h-45.3L.002 7.35v45.3L7.352 60h45.3l7.35-7.35V7.35z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M42.427 48.393H17.783V42.45l11.521-10.798c3.462-3.255 5.735-6.251 5.735-9.764 0-3.204-2.635-4.909-5.321-4.909-3.203 0-5.477 2.325-5.477 5.839h-6.665c.31-7.44 5.529-11.212 12.142-11.212 7.078 0 11.728 3.772 11.728 10.282 0 5.218-3.72 9.196-7.388 12.658l-8.939 8.473h17.308z"
})));
export default SvgLoyaltyTier2;